<div id="go-uploader-container"></div>
